module.exports = __webpack_public_path__ + "static/media/LB-white.babc759a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/assets/LB-white.svg
// module id = 241
// module chunks = 241 242 243